const AvailabilityBadge = () => {
  // rendering availability badge component here
  return (
    <div className='absolute right-1 bottom-2 size-5 rounded-full bg-base-cyan border-2 border-base-light-green'></div>
  );
};

export default AvailabilityBadge;
